import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";

import { report_billing } from "../../../components/Report.js";
export default class Billings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_view: false,

      filter_search: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_status: "",

      data: [],
      count: 10,
      data_customer: [],
      data_invoice: [],

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",

      filter_bill_search: "",
      filter_bill_date: "",
      filter_bill_duedate: "",

      billing_document_no: "",
      credit_note: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    const { filter_search, filter_start_date, filter_end_date, filter_status } =
      this.state;
    let data, count, data_customer;
    loading(true);
    let [result, result_customer] = await Promise.all([
      GET("admin/billing-notes/list", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date
          ? format_date(filter_start_date, "yyyy-mm-dd", "en")
          : "",
        end_date: filter_end_date
          ? format_date(filter_end_date, "yyyy-mm-dd", "en")
          : "",
        status_code: filter_status,
      }),
      GET("admin/setting/customers/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_customer?.status) {
      data_customer = result_customer.data.map((e) => ({
        value: e.uid,
        label: `${e.full_name}${e.customer_code ? ` ${e.customer_code} | ` : ""}${e.phone ? ` (${e.phone}) ` : ""} ${
            e.address ? ` | ${e.address}` : ""
          }`,
      }));
    }

    this.setState({
      data,
      count,
      data_customer,
    });
    loading(false);
  };
  GetInvoice = async (id) => {
    loading(true);
    let [result] = await Promise.all([
      GET("admin/invoices/list", {
        page: 0,
        data_search: this.state.filter_search,
      }),
    ]);
    if (result?.status) {
      this.setState({
        data_invoice: result.data.filter(
          (e) => e.sale.customer.uid === id && e.status === "รอชำระ"
        ),
      });
    }
    loading(false);
  };
  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ยกเลิกข้อมูล",
        "ยืนยันการยกเลิกรายการนี้หรือไม่ ?",
        "ยกเลิกข้อมูล",
        "ยกเลิก"
      )
    ) {
      loading(true);
      let result = await PUT("admin/billing-notes/update/" + id, {
        status: "ยกเลิก",
      });
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_create,
      modal_view,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_status,
      data,
      count,
      data_invoice,
      data_customer,

      id,
      uid,
      bank_name,
      account_number,
      account_name,
      customer_id,

      filter_bill_search,
      filter_bill_date,
      filter_bill_duedate,
      billing_document_no,
      credit_note,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการใบวางบิล</h4>

              <button
                className="btn btn-dark px-4 mb-3"
                onClick={() => {
                  window.location.href = "/invoice/create-billings";
                }}
              >
                สร้างใบวางบิล
              </button>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <select
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="">เลือกสถานะ</option>
                <option value="รอชำระ">รอชำระ</option>
                <option value="ใบวางบิล">ใบวางบิล</option>
                <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                <option value="เกินกำหนดชำระ">เกินกำหนดชำระ</option>
                <option value="ชำระแล้ว">ชำระแล้ว</option>
                <option value="ยกเลิก">ยกเลิก</option>
              </select>

              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่สินค้า</td>
                    <td className="text-nowrap">รหัสเอกสาร</td>
                    <td className="text-nowrap">ชื่อลูกค้า</td>
                    <td className="text-nowrap">กำหนดชำระ</td>
                    <td className="text-nowrap text-end">ยอดรวมทั้งหมด</td>
                    <td className="text-nowrap text-end">ลดหนี้</td>
                    <td className="text-nowrap text-end">มูลค่าหลังลดหนี้</td>
                    <td className="text-nowrap text-end">ชำระแล้ว</td>
                    <td className="text-nowrap text-end">ค้างชำระ</td>
                    <td className="text-nowrap text-end">ยอดคืนลูกค้า</td>
                    <td className="text-nowrap">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        {item.created_at ? format_date(item.created_at) : ""}
                      </td>
                      <td className="text-nowrap">{item.document_no || ""}</td>
                      <td className="text-nowrap">
                        {item.customer?.full_name || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.due_date ? format_date(item.due_date) : ""}
                      </td>
                      <td className="text-nowrap text-end">
                        {(() => {
                          let total = 0;
                          item.invoice.forEach((invoice) => {
                              total += Number(invoice?.sale?.amount) + Number(invoice?.sale?.vat);
                          });
                          return toFixed(total);
                        })()}
                      </td>
                      <td className="text-nowrap text-end">
                        {(() => {
                          let total = 0;
                          item.invoice.forEach((invoice) => {
                            invoice.credit_note.forEach((credit) => {
                              total += Number(credit?.amount);
                            });
                          });
                          return toFixed(total);
                        })()}
                      </td>
                      <td className="text-nowrap text-end">
                        {(() => {
                          let total = 0;
                          item.invoice.forEach((invoice) => {
                            invoice.credit_note.forEach((credit) => {
                              total += Number(invoice?.sale?.amount) + Number(invoice?.sale?.vat) - Number(credit?.amount) ;
                            });
                          });
                          return toFixed(total);
                        })()}
                      </td>
                      <td className="text-nowrap text-end">
                        {(() => {
                          let total = 0;
                          item.invoice.forEach((invoice) => {
                            total += Number(invoice.sale?.total_pay);
                          });
                          return toFixed(total);
                        })()}
                      </td>
                      <td className="text-nowrap text-end">
                        {(() => {
                          let total = 0;
                          item.invoice.forEach((invoice) => {
                            invoice.credit_note.forEach((credit) => {
                              total += (Number(invoice?.sale?.amount) + Number(invoice?.sale?.vat)) - Number(credit?.amount) - Number(invoice.sale?.total_pay);
                            });
                          });
                          return toFixed(total);
                        })()}
                      </td>
                      <td className="text-nowrap text-end">
                        {(() => {
                          let amount = 0;
                          let total = 0;
                          let credit_note = 0;
                          item.invoice.forEach((invoice) => {
                            amount += Number(invoice?.sale?.amount) + Number(invoice?.sale?.vat);
                            total += Number(invoice.sale?.total_pay);
                            invoice.credit_note.forEach((credit) => {
                              credit_note += Number(credit?.amount);
                            });
                          });
                          return toFixed(amount - total - credit_note < 0 ? (amount - total - credit_note) * -1 : 0);
                        })()}
                      </td>
                      <td className="text-nowrap">{item.status}</td>
                      <td className="text-center align-middle">
                        <div className="d-flex">
                          {item.status === "เสร็จสิ้น" && (
                            <BtnIcon
                              type="view"
                              onClick={() => {
                                window.location.href =
                                  "/invoice/payment-billings?id=" + item.uid+ "&type=view";
                              }}
                            />
                          )}
                          {item.status === "รอชำระ" && (
                            <BtnIcon
                              type="update"
                              onClick={() => {
                                window.location.href =
                                  "/invoice/payment-billings?id=" + item.uid;
                              }}
                            />
                          )}
                          <BtnIcon type="print" onClick={() => {
                            report_billing(item.uid);
                          }} />
                          {(() => {
                            let total = 0;
                            item.invoice.forEach((item) => {
                              total += Number(item.sale?.total_pay);
                            });
                            return toFixed(total);
                          })() && item.status === "รอชำระ" ? (
                            <BtnIcon
                              type="delete"
                              onClick={() => {
                                this.Delete(item.uid);
                              }}
                            />
                          ) : null}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
      </div>
    );
  }
}
